export default __webpack_public_path__ + "media/zurb/img/playground/time-on-task-icon-c8caff77602e08b21e3c917b65bbc7ca.svg";